module.exports = __webpack_public_path__ + "img/icon_footer_league.0e14cf52.svg";